export default __webpack_public_path__ + "static/media/Element-5.afc10e09.png";